import api from './config';

export const getActivities = async () => {
  try {
    const response = await api.get('/activity');
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
};

export const uploadActivity = async (activityData) => {
  try {
    const formData = new FormData();
    formData.append('name', activityData.name);
    formData.append('description', activityData.description);
    formData.append('airDensity', activityData.airDensity);
    formData.append('cyclistWeight', activityData.cyclistWeight);
    formData.append('luggageWeight', activityData.luggageWeight);
    formData.append('rollingResistanceCoefficient', activityData.rollingResistanceCoefficient);
    formData.append('mechanicalEfficiency', activityData.mechanicalEfficiency);
    formData.append('data', activityData.data);

    const response = await api.post('/activity', formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
};

export const deleteActivity = async (activityId) => {
  try {
    const response = await api.delete(`/activity/${activityId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
};

export const downloadActivity = async (activityId) => {
  try {
    const response = await api.get(`/activity/${activityId}/download`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
};

export const getActivityById = async (activityId) => {
  try {
    const response = await api.get(`/activity/${activityId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
}